<div [style.width]="tableWidth">
  <div class="options">

    <div *ngIf="tableOptions.showTableHeader" class="table-header">
      <h2>{{tableOptions.tableHeader}}</h2>
    </div>


    <div class="flex-end table-filters">
      <!-- search -->
      <div *ngIf="tableOptions.showSearch" class="search">
        <ion-input type="text" [(ngModel)]="searchFilter" placeholder="Enter Search Criteria"
          (ngModelChange)="filterDataset()"></ion-input>
      </div>

      <!-- filters -->
      <div *ngFor="let filter of tableOptions.filters" class="filter">
        <ion-select (ionChange)="filterDataset(filter)" [(ngModel)]="filtersSelected[filter.field]" interface="popover">
          <ion-select-option *ngIf="filter.unselectedLabel != null"
            value="">{{filter.unselectedLabel}}</ion-select-option>
          <ion-select-option *ngFor="let item of filter.values; let i = index" [value]="item">
            {{ filter.labels && filter.labels[i] !== null ? filter.labels[i] : filter.values[i] }}
          </ion-select-option>
        </ion-select>
      </div>

      <div *ngIf="customFilterTemplate != null" class="filter">
        <ng-container *ngTemplateOutlet="customFilterTemplate; context: { }"></ng-container>
      </div>

    </div>

    <!-- media -->
    <input style="display: none;" #fileInput type="file" [accept]="tableOptions.mediaOptions"
      (change)="uploadMedia($event)">

    <!-- Import button -->
    <ion-button *ngIf="tableOptions.showImportButton" [disabled]="busy" [class.margin-top]="tableOptions.showSearch"
      class="header-button" color="primary" (click)="fileInput.click()">
      Import {{tableOptions.type}}
    </ion-button>

    <div class="row-buttons ion-text-right">
      <!-- add item button -->
      <ion-button *ngIf="tableOptions.addType === 2" [disabled]="busy" [class.margin-top]="tableOptions.showSearch"
        color="primary" class="header-button" (click)="addBtnClicked()">
        Add {{tableOptions.addBtnLabel ? tableOptions.addBtnLabel : tableOptions.type}}
      </ion-button>

      <ng-container *ngFor="let btn of tableOptions.customButtons">
        <ion-button [ngClass]="btn.cssClass" [disabled]="btn.disabled" [class.margin-top]="tableOptions.showSearch"
          color="primary" class="header-button r" (click)="runCustomClick(btn.click)">{{btn.label}}</ion-button>
        <app-help-icon *ngIf="btn.helpText != null" [helpText]="btn.helpText" [title]="btn.label"></app-help-icon>
      </ng-container>

      <ion-button *ngIf="tableOptions.showReorder" shape="round" [class.margin-top]="tableOptions.showSearch"
        color="secondary" class="header-button" (click)="reorder = !reorder">{{reorder ? 'Done' : 'Sort'}}</ion-button>

      <ion-button *ngIf="tableOptions.showHeaderExpand" fill="outline"
        [color]="headersExpanded ? 'primary' : 'medium'"
        class="header-button header-expand-btn" [class.active]="headersExpanded" (click)="headersExpanded = !headersExpanded">
        <ng-container *ngIf="headersExpanded">
          Collapse Questions
          <ion-icon slot="icon-only" name="chevron-up-outline"></ion-icon>
        </ng-container>
        <ng-container *ngIf="headersExpanded === false">
          Expand Questions
          <ion-icon slot="icon-only" name="chevron-down-outline"></ion-icon>
        </ng-container>
      </ion-button>
    </div>
  </div>

  <div [class]="tableOptions.tableCssClass ?? 'data-table'" [class.headers-expanded]="headersExpanded"
    [class.scrolled-x]="isScrolledX" (scroll)="onTableScroll($event)">

    <table *ngIf="reorder === false">
      <!-- header row -->
      <tr>
        <th *ngIf="tableOptions.includePkCheckbox === true"></th>
        <th *ngFor="let item of tableOptions.headers; let i = index" [class.sortable]="item.sortable"
          [class.sticky-col]="item.sticky" tappable
          (click)="sort(item)" [ngClass]="{'ion-text-right': item.isNumber }"
          [style.min-width]="item.minWidth ? item.minWidth : null"
          [title]="item.isLocked != null ? 'This field cannot be edited once sales starts' : item.label">
          <span class="th-label">{{item.label}}</span>
          <ion-icon *ngIf="item.sortable && sortBy === item.field"
            [name]="sortAsc ? 'chevron-down-outline' : 'chevron-up-outline'"></ion-icon>
          <ion-icon *ngIf="sortBy !== item.field && item.sortable" name="swap-vertical-outline"
            color="medium"></ion-icon>
          <ion-icon slot="start" *ngIf="item.isLocked != null" class="no-pointer-evts"
            [name]="(item.isLocked === true) ? 'lock-closed-outline' : 'lock-open-outline'"></ion-icon>
          <app-help-icon *ngIf="item.helpText != null" [helpText]="item.helpText" [title]="item.label"></app-help-icon>
        </th>
        <th *ngIf="tableOptions.includeRowButton === true" class="no-border">{{ tableOptions.rowButtonHeader }}</th>
        <th *ngIf="tableOptions.allowEdit || tableOptions.allowDelete || tableOptions.addType === 1" class="no-border">
        </th>
      </tr>

      <!-- data row -->
      <tr *ngFor="let item of 
                  (tableOptions.includePagination === true 
                    ? (filteredDataSet | paginate: { itemsPerPage: tableOptions.paginationItemsPerPage, currentPage: tableOptions.paginationCurrentPage, totalItems
                    : tableOptions.paginationTotalItems }) : filteredDataSet) ; let itemIndex = index"
        (click)="selectByPk(item)" tappable
        [class.disabled]="tableOptions.propertyForDisabled != null && item[tableOptions.propertyForDisabled]===true"
        [style.border-left]="item?.color ? '20px solid ' + item.color : 'none'"
        [style.background]="item[tableOptions.bgProp]" [class.even]="itemIndex % 2 === 0">

        <!-- first column checkbox -->
        <td *ngIf="tableOptions.includePkCheckbox && tableOptions.primaryKey != null">
          <ion-checkbox color="primary" slot="start" [(ngModel)]="pkSelected[item[tableOptions.primaryKey]]">
          </ion-checkbox>
        </td>

        <!-- now add all columns defined in tableOptions.columns -->
        <ng-container *ngFor="let col of tableOptions.columns; let i = index">
          <!-- standard single cell columns -->
          <td [style.max-width]="col.maxWidth" [style.min-width]="col.minWidth" *ngIf="col.type !== 'text-array'"
            [class.sticky-col]="tableOptions.headers[i]?.sticky"
            [style.text-wrap]="col.nowrap ? 'nowrap' : 'pretty'" [ngClass]="{
              'ion-text-left': col.type === 'checkbox' || col.type === 'content',
              'ion-text-right': col.type === 'number' || col.type === 'currency' || col.type === 'percent',
              'ion-text-center': col.type === 'boolean' || col.type === 'icon'
            }" [class.shrink]="col.shrinkCell" [class]="col.customColor == null ? '' : (item[col.customColor] ?? '')">
            <span *ngIf="(i === 0 && tableOptions.indicateNewItems === true)"
              [class.notify]="item[tableOptions.newItemLookUp]">&nbsp;</span>

            <!-- if clickable columns enabled and this column, display value as link with click handler -->
            <span
              *ngIf="(i === tableOptions.clickableColumn && tableOptions.enableClickableColumn === true && col.type !== 'checkbox')"
              (click)="columnClick(item)" class="link">
              {{item[col.classProperty]}}
            </span>

            <span *ngIf="col.linkCallback != null" (click)="col.linkCallback(item)" class="link">
              {{item[col.classProperty]}}
            </span>

            <span *ngIf="tableOptions.enableClickableColumnForCheckCol === true && i === tableOptions.clickableColumn"
              (click)="columnClick2(item.value)"
              [class]="tableOptions.propertyForDisabled != null && item[tableOptions.propertyForDisabled] === true ? 'disabled-link' : 'link'">
              {{item[col.classProperty]}}
            </span>

            <!-- if clickable columns disabled, or not this column, just display the value -->
            <ng-container
              *ngIf="!editItemDic[itemIndex] && col.copyIconOnly !== true && tableOptions.clickableColumn !== i && col.linkCallback == null">
              <span
                *ngIf="(i !== tableOptions.clickableColumn || tableOptions.enableClickableColumn === false) && col.type != null && ![ 'content', 'checkbox', 'number', 'currency', 'select', 'url', 'tel', 'button', 'button-array', 'date', 'boolean', 'icon'].includes(col.type)">
                {{(item[col.classProperty] === true) ? 'Y' : (item[col.classProperty] === false) ? 'N' :
                item[col.classProperty]}}
              </span>

              <ng-container *ngIf="col.type === 'icon' && item[col.classProperty] != null">
                <ion-icon [name]="col.icon" (click)="col.callback($event, item[col.classProperty])" color="primary"
                  class="icon-cell"></ion-icon>
              </ng-container>

              <span
                *ngIf="!['checkbox', 'number', 'currency', 'percent', 'select', 'url', 'button', 'date', 'icon', 'boolean', 'tel'].includes(col.type)">
                {{ item[col.classProperty] }}
              </span>

              <ng-container *ngIf="col.type === 'boolean'">
                <span *ngIf="item[col.classProperty] === true">Yes</span>
                <span *ngIf="item[col.classProperty] === false">No</span>
              </ng-container>


              <!-- this is a checkbox column -->
              <span *ngIf="col.type === 'checkbox'">
                <app-checkbox-input [disabled]="true" [(ngModel)]="item[col.classProperty]"></app-checkbox-input>
              </span>
              <span *ngIf="col.type === 'content'">
                <img *ngIf="item[col.classProperty].path" [src]="item[col.classProperty].path"
                  [height]="tableOptions.contentUploadConfig?.previewHeight" alt="image">
                <p *ngIf="!item[col.classProperty].path">No Image</p>
              </span>
              <span *ngIf="col.type === 'date'">
                {{ item[col.classProperty] == null ? '-' : item[col.classProperty] | luxon: col.dateFormat }}
              </span>
              <span *ngIf="col.type === 'number'">
                {{ item[col.classProperty] == null ? '-' : item[col.classProperty] | number }}
              </span>
              <span *ngIf="col.type === 'tel'">
                {{ item[col.classProperty] == null ? '-' : item[col.classProperty] | phone }}
              </span>
              <span *ngIf="col.type === 'currency'">
                {{ item[col.classProperty] == null ? '-' : item[col.classProperty] | currency: (col.currencyCol ?
                item[col.currencyCol] : col.currency) : 'symbol-narrow' : col.currencyFormat }}
              </span>
              <span *ngIf="col.type === 'select'">
                {{ getOptionDisplayValue(col.classProperty, item[col.classProperty]) }}
              </span>
              <span *ngIf="col.type === 'url'">
                <a *ngIf="col.url != null" (click)="openUrl(item[col.url])">{{ item[col.classProperty] }}</a>
                <a *ngIf="col.url == null" (click)="openUrl(item[col.classProperty])">{{ item[col.classProperty] }}</a>
              </span>
              <span *ngIf="col.type === 'button'">
                <ion-button [color]="(col.customColor != null) ? (item[col.customColor] ?? 'secondary') : 'secondary'"
                  size="small" (click)="col.callback(item)">
                  {{col.displayValue != null ? item[col.displayValue] : ''}}</ion-button>
              </span>
              <span *ngIf="col.type === 'button-array'">
                <ion-button *ngFor="let button of col.buttons" size="small"
                  [color]="(col.customColor != null) ? (item[col.customColor] ?? 'secondary') : 'secondary'"
                  (click)="button.click(item)">
                  {{button.label}}</ion-button>
              </span>
            </ng-container>
            <ng-container *ngIf="col.showWarningIcon === true && item['showWarningIcon'] === true">
              <ion-icon color="warning" name="warning-outline"></ion-icon>
            </ng-container>

            <!-- Editable input -->
            <ng-container *ngIf="editItemDic[itemIndex]">
              <span *ngIf="(i !== tableOptions.clickableColumn || tableOptions.enableClickableColumn === false)">
                <ng-container *ngIf="!col.enableInlineEdit">
                  <span
                    *ngIf="col.type != null && !['checkbox', 'number', 'currency', 'select', 'url', 'button'].includes(col.type)">
                    {{ item[col.classProperty] }}
                  </span>
                  <span *ngIf="col.type === 'number'">
                    {{ item[col.classProperty] | number }}
                  </span>
                  <span *ngIf="col.type === 'url'">
                    <a [href]="item[col.classProperty]" target="_blank">{{ item[col.classProperty] }}</a>
                  </span>
                  <span *ngIf="col.type === 'button'">
                    <ion-button
                      [color]="(col.customColor != null) ? (item[col.customColor] ?? 'secondary') : 'secondary'"
                      size="small" (click)="col.callback(item)">{{col.displayValue != null ? item[col.displayValue] :
                      ''}}
                    </ion-button>
                  </span>
                  <span *ngIf="col.type === 'currency'">
                    {{ item[col.classProperty] | currency: col.currency : 'symbol-narrow' : col.currencyFormat }}
                  </span>
                  <span *ngIf="col.type === 'select'">
                    {{ getOptionDisplayValue(col.classProperty, item[col.classProperty]) }}
                  </span>
                  <span *ngIf="col.type === 'checkbox'">
                    <app-checkbox-input [disabled]="true" [(ngModel)]="item[col.classProperty]"></app-checkbox-input>
                  </span>
                </ng-container>
                <ng-container *ngIf="col.enableInlineEdit" [ngSwitch]="col.type">
                  <ng-container *ngSwitchCase="'date'">
                    <span *ngIf="col.displayValue">
                      <span>{{item[col.displayValue | luxon]}}</span>
                      <span class="dateinput-toggle" (click)="pickDate(itemIndex)">
                        <input type="date" #dateInput class="date-input" [value]="item[col.displayValue]"
                          (change)="onBlur(item[tableOptions.primaryKey ?? ''], $event)">
                        <ion-icon name="calendar-outline"></ion-icon>
                      </span>
                    </span>
                    <app-datetime-input *ngIf="col.displayValue == null" [type]="'date'"
                      [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                      errorDisplay="inline">
                    </app-datetime-input>
                  </ng-container>
                  <app-email-input *ngSwitchCase="'email'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                    errorDisplay="inline">
                  </app-email-input>
                  <app-number-input *ngSwitchCase="'number'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                    errorDisplay="inline">
                  </app-number-input>
                  <app-datetime-input *ngSwitchCase="'time'" [placeholder]="tableOptions.headers[i].label"
                    [type]="'time'" [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                    errorDisplay="inline">
                  </app-datetime-input>
                  <app-checkbox-input *ngSwitchCase="'checkbox'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                    errorDisplay="inline">
                  </app-checkbox-input>
                  <app-select-input *ngSwitchCase="'select'" [placeholder]="'Select ' + tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [options]="col.options"
                    [required]="col.isRequired" errorDisplay="inline"></app-select-input>
                  <app-number-input *ngSwitchCase="'currency'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [maxlength]="col.maxLength"
                    [currency]="col.currency" [required]="col.isRequired" errorDisplay="inline"></app-number-input>
                  <app-phone-input *ngSwitchCase="'tel'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                    errorDisplay="inline">
                  </app-phone-input>
                  <app-content-upload *ngSwitchCase="'content'" uploadTitle="" [showUploadButtonText]="false"
                    (fileSelected)="selectedFile($event, itemIndex)" (fileRemoved)="clearImage(itemIndex)"
                    [files]="editItemDic[itemIndex][col.classProperty]" [config]="tableOptions.contentUploadConfig">
                  </app-content-upload>
                  <app-text-input *ngSwitchDefault [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [type]="col.type"
                    [maxLength]="col.maxLength" [required]="col.isRequired" errorDisplay="inline"></app-text-input>
                </ng-container>
              </span>
            </ng-container>
            <ion-icon *ngIf="col.copyOption"
              (click)="copyToClipboard(item[col.classProperty], tableOptions.headers[i].label)"
              name="copy-outline"></ion-icon>
          </td>

          <!-- text array column -->

          <ng-container *ngIf="col.type === 'text-array'">
            <ng-container *ngIf="col.arrayProperties?.length > 0">
              <ng-container *ngFor="let array of item[col.classProperty]">
                <td *ngFor="let prop of col.arrayProperties">
                  <span>{{array[prop]}}</span>
                </td>
              </ng-container>
            </ng-container>
            <ng-container
              *ngIf="col.arrayProperty != null && !(col.arrayProperties?.length > 0); else singleArrayProperty">
              <td *ngFor="let array of item[col.classProperty]">
                <span>{{array[col.arrayProperty]}}</span>
              </td>
            </ng-container>
            <ng-template #singleArrayProperty>
              <td *ngFor="let arrayElement of item[col.classProperty]">
                <span>{{arrayElement}}</span>
              </td>
            </ng-template>

          </ng-container>

        </ng-container>

        <!-- Column containing edit and delete buttons -->
        <td class="no-border ion-text-center edit-opts" *ngIf="tableOptions.allowEdit || tableOptions.allowDelete">
          <ion-buttons>
            <ng-container *ngIf="!editItemDic[itemIndex]">
              <ion-button [disabled]="busy" *ngIf="tableOptions.allowEdit" fill="clear" color="primary"
                (click)="toggleEdit(itemIndex)">
                <ion-icon slot="icon-only" name="create-outline"></ion-icon>
              </ion-button>
              <ion-button [disabled]="busy" *ngIf="tableOptions.allowDelete" fill="clear" color="danger"
                (click)="archiveItem(itemIndex)">
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            </ng-container>
            <ng-container *ngIf="editItemDic[itemIndex]">
              <ion-button [disabled]="busy" fill="clear" color="danger" (click)="toggleEdit(itemIndex)">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
              </ion-button>
              <ion-button [disabled]="busy" fill="clear" color="success" (click)="editItem(itemIndex)">
                <ion-icon slot="icon-only" name="checkmark-outline"></ion-icon>
              </ion-button>
            </ng-container>
          </ion-buttons>
        </td>

        <td class="no-border"
          *ngIf="tableOptions.allowEdit === false && tableOptions.allowDelete === false && tableOptions.addType === 1">
        </td>

        <!-- finish off with a column holding an action button -->
        <td *ngIf="tableOptions.includeRowButton" class="no-border ion-text-right">
          <!--disabled and greyed out if the order has been delivered-->
          <ion-button id="row-btn" size="small" color="secondary" (click)="rowButtonClick($event, item)">
            {{tableOptions.rowButtonText}}</ion-button>
        </td>

        <!-- and or with a custom last column template-->
        <td *ngIf="tableOptions.includeLastColTemplate" class="no-border ion-text-right">
          <div>
            <ng-container *ngTemplateOutlet="customLastColTemplate; context: { item: item}"></ng-container>
          </div>
        </td>

      </tr>

      <!-- a totals row if specified -->
      <tr *ngIf="tableOptions.showTotalRow === true && tableOptions.dataSet.length > 0" class="total-row">
        <td *ngFor="let col of tableOptions.columns" class="ion-text-right">
          {{ col.type === 'currency' ? (getColumnTotal(col.classProperty) | currency: col.currency : 'symbol-narrow' :
          col.currencyFormat):
          (getColumnTotal(col.classProperty) | number )}}
        </td>
        <td *ngIf="tableOptions.includeRowButton"></td>
        <td *ngIf="tableOptions.allowEdit || tableOptions.allowDelete || tableOptions.addType === 1"></td>
      </tr>

      <!-- message to show if dataset is empty-->
      <tr *ngIf="tableOptions.dataSet.length === 0 || filteredDataSet.length === 0" class="ion-text-center">
        <td [attr.colspan]="tableOptions.columns.length">{{tableOptions.noItemsMessage}}</td>
        <td *ngIf="tableOptions.includeRowButton"></td>
        <td *ngIf="tableOptions.allowEdit || tableOptions.allowDelete || tableOptions.addType === 1"></td>
      </tr>

      <!-- Row added to the bottom of table if add type is INLINE -->
      <tr *ngIf="tableOptions.addType === 1">
        <td *ngFor="let col of tableOptions.columns; let colIndex = index;"
          [ngClass]="{'ion-text-center': col.type === 'checkbox', 'ion-text-right': col.type === 'number' || col.type === 'currency' , 'form-inputs': true}"
          [class.shrink]="col.shrinkCell">

          <ng-container *ngIf="col.canEdit" [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'date'">
              <span *ngIf="col.displayValue">
                <span>{{todayDateFormat}}</span>
                <span class="dateinput-toggle" (click)="newDate?.nativeElement.showPicker()">
                  <input type="date" #newDateInput class="date-input" [value]="newItem[col.classProperty]"
                    (change)="updateDateFormat($event, col.classProperty)">
                  <ion-icon name="calendar-outline"></ion-icon>
                </span>
              </span>
              <app-datetime-input *ngIf="col.displayValue == null" [type]="'date'"
                [(ngModel)]="newItem[col.classProperty]" errorDisplay="inline"></app-datetime-input>
            </ng-container>
            <app-email-input *ngSwitchCase="'email'" [(ngModel)]="newItem[col.classProperty]"
              [placeholder]="tableOptions.headers[colIndex].label" [maxLength]="col.maxLength"
              [required]="col.isRequired" errorDisplay="inline"></app-email-input>
            <app-number-input *ngSwitchCase="'number'" [maxLength]="col.maxLength"
              [(ngModel)]="newItem[col.classProperty]" [placeholder]="tableOptions.headers[colIndex].label"
              [required]="col.isRequired" errorDisplay="inline">
            </app-number-input>
            <app-datetime-input *ngSwitchCase="'time'" [type]="'time'" [(ngModel)]="newItem[col.classProperty]"
              [required]="col.isRequired" errorDisplay="inline"></app-datetime-input>
            <app-checkbox-input *ngSwitchCase="'checkbox'" [(ngModel)]="newItem[col.classProperty]"
              [required]="col.isRequired" errorDisplay="inline"></app-checkbox-input>
            <app-select-input *ngSwitchCase="'select'" [placeholder]="'Select ' + tableOptions.headers[colIndex].label"
              [(ngModel)]="newItem[col.classProperty]" [options]="col.options" [required]="col.isRequired"
              errorDisplay="inline">
            </app-select-input>
            <app-number-input *ngSwitchCase="'currency'" [placeholder]="tableOptions.headers[colIndex].label"
              [(ngModel)]="newItem[col.classProperty]" [maxLength]="col.maxLength" [required]="col.isRequired"
              errorDisplay="inline" [currency]="col.currency"></app-number-input>
            <app-phone-input *ngSwitchCase="'tel'" [placeholder]="tableOptions.headers[colIndex].label"
              [(ngModel)]="newItem[col.classProperty]" [required]="col.isRequired"
              errorDisplay="inline"></app-phone-input>
            <app-content-upload *ngSwitchCase="'content'" uploadTitle="" [showUploadButtonText]="false"
              (fileSelected)="selectedFile($event)" (fileRemoved)="clearImage()" [files]="newItem[col.classProperty]"
              [config]="tableOptions.contentUploadConfig">
            </app-content-upload>
            <app-text-input *ngSwitchDefault [placeholder]="tableOptions.headers[colIndex].label"
              [(ngModel)]="newItem[col.classProperty]" [type]="col.type" [maxLength]="col.maxLength"
              [required]="col.isRequired" errorDisplay="inline"></app-text-input>
          </ng-container>
        </td>
        <td class="ion-text-center">
          <ion-button [disabled]="busy" fill="solid" color="success" (click)="addItem()">Add</ion-button>
        </td>
        <td *ngIf="tableOptions.includeRowButton"></td>
      </tr>

    </table>

    <pagination-controls *ngIf="tableOptions.includePagination"
      (pageChange)="tableOptions.paginationCurrentPage = $event"></pagination-controls>


    <!-- Will replace the current table when the user toggles the table re-order -->
    <ion-reorder-group *ngIf="reorder === true" (ionItemReorder)="reorderItems($event)" disabled="false">
      <ion-reorder *ngFor="let item of tableOptions.dataSet">
        <ion-item>
          <div *ngFor="let col of tableOptions.columns; let i = index">
            <span *ngIf="col.type !== 'content'">
              {{tableOptions.headers[i].label}}: {{item[col.classProperty]}}
            </span>
          </div>
        </ion-item>
      </ion-reorder>
    </ion-reorder-group>

  </div>
</div>